export * from './lib/get-base-path';